import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs';
import { errorHandl } from 'src/app/utils/network-utils';
import { urls } from 'src/app/utils/url.utils';

@Injectable({
  providedIn: 'root'
})
export class BillingService {

  constructor(private http: HttpClient) { }

  adjustTrip(payload: any, isFromBilling: boolean, tripId: any) {
    if (isFromBilling) {
      return this.http.patch(urls.API_URL + urls.ADJUST_TRIPS + `/${tripId}`, payload)
        .pipe(catchError(errorHandl));
    }else{
      return this.http.post(urls.API_URL + urls.ADJUST_TRIPS, payload)
        .pipe(catchError(errorHandl));
    }

  }

  getBillingTrips(queryParam:any) {
      const params = new HttpParams({fromObject: queryParam});
      return this.http.get(urls.API_URL + urls.ADJUST_TRIPS, {params})
        .pipe(catchError(errorHandl));
    }

     getReportTrips(queryParam:any) {
      const params = new HttpParams({fromObject: queryParam});
    return this.http.get(urls.API_URL + urls.RAW_REPORT, {params})
        .pipe(catchError(errorHandl));
    }

  bulkAdjustEvents(payload: any) {
    return this.http.post(urls.API_URL + urls.ASSIGN_EVENTS + '/bulk', payload)
      .pipe(catchError(errorHandl));
  }
  
  getTripById(id: any) {
    return this.http.get(urls.API_URL + urls.ADJUST_TRIPS + `/${id}`)
      .pipe(catchError(errorHandl));
  }

  billingSignatureUpdate(payload:any,isFromBilling: boolean,tripId:any){
    return this.http.post(urls.API_URL + urls.ADJUST_TRIPS +'/'+tripId +'/'+ urls.SIGNATURE_UPDATE ,payload)
      .pipe(catchError(errorHandl))
  }

  getConfigurations() {
    return this.http
      .get(urls.API_URL + urls.CONFIGURATIONS)
      .pipe(catchError(errorHandl));
  }
}
